import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    standalone: false
})
export class ButtonComponent {
  @Input() status = 'primary';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  @Input() disabled = false;
  @Input() isProcessing = false;
  @Input() tooltip: string | null = null;
  @Output() click = new EventEmitter();

  handleClick(event?: Event) {
    event?.stopPropagation();
    this.click.emit();
  }
}
